import _objectSpread from "@babel/runtime/helpers/objectSpread2";
var _Toaster;
import { useMe } from '@crehana/auth';
import { useUITheme } from '@crehana/compass.ui';
import { Toaster } from '@crehana/compass.ui/toaster';
import { clsx } from 'clsx';
import { Header, HeaderNightSwitch, LanguageSelector, Links, LogoutButton, ProfileButton, ProfileInnerSelectors } from "./components";
import { ExitImpressionation } from "./components/exit-impressionation/exit-impressionation";
import { HeaderSwitcher } from "./components/header-switcher";
import { useContainerRef } from "./hooks";
import { useSupplanting } from "./hooks/use-supplanting/use-supplanting";
import useProfileData from "./hooks/useProfileData";
import { useProfileUITranslations } from "./i18n";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var ProfileInner = function ProfileInner(_ref) {
  var _links$find;
  var user = _ref.user,
    userRoleLabel = _ref.userRoleLabel,
    _ref$userRoles = _ref.userRoles,
    userRoles = _ref$userRoles === void 0 ? [] : _ref$userRoles,
    toggleDarkMode = _ref.toggleDarkMode,
    links = _ref.links,
    canRenderCompaniesDropdown = _ref.canRenderCompaniesDropdown,
    _ref$organizationsLis = _ref.organizationsList,
    organizationsList = _ref$organizationsLis === void 0 ? [] : _ref$organizationsLis,
    defaultSelectedOrganization = _ref.defaultSelectedOrganization,
    defaultSelectedRole = _ref.defaultSelectedRole,
    isDark = _ref.isDark,
    organizationSlug = _ref.organizationSlug,
    enableUserPermissions = _ref.enableUserPermissions;
  var _useProfileUITranslat = useProfileUITranslations(),
    t = _useProfileUITranslat.t;
  var _useContainerRef = useContainerRef(),
    containerRef = _useContainerRef.containerRef,
    isOpen = _useContainerRef.isOpen,
    setIsOpen = _useContainerRef.setIsOpen;
  var _useSupplanting = useSupplanting(),
    isSupplanting = _useSupplanting.isSupplanting,
    mainUserId = _useSupplanting.mainUserId;
  var profileUrl = (_links$find = links.find(function (link) {
    return link.key === 'profile';
  })) === null || _links$find === void 0 ? void 0 : _links$find.url;
  return /*#__PURE__*/_jsx("div", {
    className: "tw-flex md:tw-items-center tw-ml-1.6",
    ref: containerRef,
    children: /*#__PURE__*/_jsxs("div", {
      className: "tw-relative tw-cursor-pointer tw-flex",
      children: [isSupplanting && /*#__PURE__*/_jsx("div", {
        className: "tw-hidden md:tw-flex tw-bg-neutral-dark-200 tw-rounded-l-1 tw-rounded-r-2.4 tw-py-0.8 tw-pl-1.2 tw-pr-2.4 tw-mr-1.2 tw-items-center tw-justify-center",
        children: /*#__PURE__*/_jsx("p", {
          className: "tw-font-link1 tw-text-primary-light-700",
          children: t('SWITCHER_SUPPLANTED')
        })
      }), /*#__PURE__*/_jsx(ProfileButton, {
        toggleOpen: function toggleOpen() {
          return setIsOpen(function (prev) {
            return !prev;
          });
        },
        user: user,
        isOpen: isOpen,
        userRoleLabel: userRoleLabel
      }), /*#__PURE__*/_jsx("div", {
        className: clsx('tw-absolute -tw-right-1 tw-top-3.2 tw-pt-2 tw-transition-opacity', isOpen ? 'tw-opacity-100 tw-pointer-events-auto' : 'tw-opacity-0 tw-pointer-events-none'),
        style: {
          perspective: '2000px',
          zIndex: 1200
        },
        children: /*#__PURE__*/_jsx("div", {
          className: clsx('tw-rounded-1', isOpen && 'tw-transform-none', !isDark && 'tw-shadow-01'),
          children: /*#__PURE__*/_jsxs("div", {
            className: "tw-rounded-1 dark:tw-bg-elevation-dark-04 tw-bg-neutral-light-100",
            children: [isSupplanting && /*#__PURE__*/_jsx(ExitImpressionation, {
              organizationSlug: organizationSlug
            }), /*#__PURE__*/_jsxs("div", {
              className: "tw-p-2 tw-w-28",
              children: [isSupplanting && /*#__PURE__*/_jsx(HeaderSwitcher, {
                organizationSlug: organizationSlug,
                mainUserId: mainUserId
              }), /*#__PURE__*/_jsxs("div", {
                className: clsx(isSupplanting && 'tw-bg-neutral-dark-200 tw-p-2 tw-rounded-1'),
                children: [/*#__PURE__*/_jsx(Header, {
                  user: user,
                  isSupplanting: isSupplanting,
                  profileUrl: profileUrl
                }), /*#__PURE__*/_jsx(Links, {
                  links: links,
                  isSupplanting: isSupplanting
                }), /*#__PURE__*/_jsx(ProfileInnerSelectors, {
                  canRenderCompaniesDropdown: canRenderCompaniesDropdown,
                  organizationsList: organizationsList,
                  defaultSelectedOrganization: defaultSelectedOrganization,
                  organizationSlug: organizationSlug,
                  isSupplanting: isSupplanting,
                  userRoles: userRoles,
                  defaultSelectedRole: defaultSelectedRole,
                  enableUserPermissions: enableUserPermissions
                }), /*#__PURE__*/_jsx(LanguageSelector, {
                  isSupplanting: isSupplanting
                }), toggleDarkMode && /*#__PURE__*/_jsx(HeaderNightSwitch, {
                  toggleDarkMode: toggleDarkMode,
                  isDark: isDark,
                  isSupplanting: isSupplanting
                })]
              }), /*#__PURE__*/_jsx(LogoutButton, {
                isSupplanting: isSupplanting
              })]
            })]
          })
        })
      })]
    })
  });
};
var ProfileUI = function ProfileUI(_ref2) {
  var hideLeaderOrSupervisorInNavbarLabel = _ref2.hideLeaderOrSupervisorInNavbarLabel,
    hideLeaderItemInRoleSelector = _ref2.hideLeaderItemInRoleSelector,
    organizationSlug = _ref2.organizationSlug,
    currentUrl = _ref2.currentUrl;
  var _useMe = useMe(),
    updateMe = _useMe.updateMe,
    talentUser = _useMe.talentUser;
  var hasTalentProduct = talentUser.hasTalentProduct;
  var customCollaboratorUrl = hasTalentProduct ? "/org/".concat(organizationSlug, "/home/") : '';
  var _useUITheme = useUITheme(),
    toggleTheme = _useUITheme.toggleTheme,
    isDark = _useUITheme.isDark;
  var _useProfileData = useProfileData({
      organizationSlug: organizationSlug,
      customCollaboratorUrl: customCollaboratorUrl,
      currentUrl: currentUrl,
      hideLeaderItemInRoleSelector: hideLeaderItemInRoleSelector,
      hideLeaderOrSupervisorInNavbarLabel: hideLeaderOrSupervisorInNavbarLabel
    }),
    userRoleLabel = _useProfileData.userRoleLabel,
    userRoles = _useProfileData.userRoles,
    canRenderCompaniesDropdown = _useProfileData.canRenderCompaniesDropdown,
    defaultSelectedRole = _useProfileData.defaultSelectedRole,
    me = _useProfileData.me,
    links = _useProfileData.links,
    organizationsList = _useProfileData.organizationsList,
    defaultSelectedOrganization = _useProfileData.defaultSelectedOrganization,
    shouldRenderNightSwitch = _useProfileData.shouldRenderNightSwitch;
  var toggleDarkMode = function toggleDarkMode() {
    toggleTheme();
    updateMe(function (prevData) {
      var _prevData$me, _prevData$me2, _prevData$me2$setting;
      return _objectSpread(_objectSpread({}, prevData), {}, {
        me: _objectSpread(_objectSpread({}, prevData.me), {}, {
          settings: _objectSpread(_objectSpread({}, (_prevData$me = prevData.me) === null || _prevData$me === void 0 ? void 0 : _prevData$me.settings), {}, {
            darkMode: !((_prevData$me2 = prevData.me) !== null && _prevData$me2 !== void 0 && (_prevData$me2$setting = _prevData$me2.settings) !== null && _prevData$me2$setting !== void 0 && _prevData$me2$setting.darkMode)
          })
        })
      });
    });
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [_Toaster || (_Toaster = /*#__PURE__*/_jsx(Toaster, {})), /*#__PURE__*/_jsx(ProfileInner, {
      toggleDarkMode: shouldRenderNightSwitch ? toggleDarkMode : undefined,
      user: me,
      userRoles: userRoles,
      defaultSelectedRole: defaultSelectedRole,
      userRoleLabel: userRoleLabel,
      canRenderCompaniesDropdown: canRenderCompaniesDropdown,
      organizationsList: organizationsList,
      defaultSelectedOrganization: defaultSelectedOrganization,
      links: links,
      isDark: isDark,
      organizationSlug: organizationSlug,
      enableUserPermissions: currentUrl === '/org/[slug]/panel'
    })]
  });
};
export default ProfileUI;